import React from 'react';

const StepTitle = ({ title, icon, required = false, $isMobile }) => {
  return (
    <div className='w-full flex flex-col items-start'>
      <div
        className={`w-full flex flex-row items-start ${
          $isMobile ? 'pb-3' : 'pb-4'
        } ${$isMobile && required ? 'gap-0.5' : required ? 'gap-1' : 'gap-1.5'}`}
      >
        {icon}
        <div
          className={`${$isMobile ? 'typo-b16Strong' : 'typo-title3'} text-text-primary`}
        >
          {title}
        </div>
        {required && (
          <span className='typo-title1 text-functional-accent03'>*</span>
        )}
      </div>
    </div>
  );
};

export default StepTitle;
